module.exports = __webpack_public_path__ + "static/media/Screenshot_2-thumb.49da966b.png";